import * as ws_base from '../ws/ws_base'


const DOMINIO = "denuncia";


export async function buscarCategorias(tipo){

	return await ws_base.get(DOMINIO, "categorias");
}


export async function novaDenuncia(id_denunciante, tipo, fk_relacao, categoria, comentario){

	return await ws_base.post(DOMINIO, "novo", {"fk_denunciante": id_denunciante, 
													"tipo": tipo, 
														"fk_relacao": fk_relacao,
															"categoria": categoria,
																"comentario": comentario});
}


export async function buscar(tipo, situacao, conclusao){

	return await ws_base.post(DOMINIO, "obter", {"tipo": tipo, 
													"categoria": null, 
														"situacao": situacao,
															"conclusao": conclusao});
}


export async function avaliar(id_denuncia,conclusao){

	return await ws_base.post(DOMINIO, "avaliar", {"id": id_denuncia, "conclusao": conclusao});
}


export async function gerarToken(id_denuncia){

	return await ws_base.post(DOMINIO, "gerarToken", {"id": id_denuncia});
}